import {Component} from '@angular/core';
import {UserService} from '../services/user/user.service';
import {NavigationService} from '../services/nav/navigation.service';

@Component({
    selector: 'app-usertype-redirect',
    template: ''
})
export class RedirectUsertypeComponent {

  private readonly pathPrefix = '/redirect-usertype';

  constructor(private userService: UserService,
              private nav: NavigationService) {
    userService.getUser().then(user => {
      nav.goto(`/${user.userType.toLowerCase()}${this.getPath()}`);
    });
  }

  private getPath(): string {
    const pathname = window.location.pathname;
    return pathname.substring(pathname.indexOf(this.pathPrefix) + this.pathPrefix.length);
  }
}
